var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
// import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
var LoaderService = /** @class */ (function () {
    // private spinnerService: Ng4LoadingSpinnerService
    function LoaderService() {
        this.loaderStatus = new BehaviorSubject(false);
    }
    // startLoadingSpinner() {
    //   this.spinnerService.show();
    // }
    //
    // stopLoadingSpinner() {
    //   // setTimeout(() => this.spinnerService.hide(), 1000);
    //   this.spinnerService.hide();
    // }
    LoaderService.prototype.displayLoader = function (value) {
        this.loaderStatus.next(value);
    };
    LoaderService = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [])
    ], LoaderService);
    return LoaderService;
}());
export { LoaderService };



//////////////////
// WEBPACK FOOTER
// ./src/app/loader.service.ts
// module id = ./src/app/loader.service.ts
// module chunks = main